export default __webpack_public_path__ + "static/media/10.601b212f.png";